//MapTips_Custom.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as Settings from "../Settings";
import * as Util from "./Util";
import * as Util_App from "./Util_App";

import { Typography } from "@mui/material";

import React from "react";

//Build the map tips. Custom! But most can be done in the Alias Name in ArcGIS Pro.
export function getMapTip(mapTipSetting: Settings.iMapTip, fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   const styles: Default.iStyles = {
      parcels: { maxHeight: 250, maxWidth: 350, overflow: 'auto' },
      //default: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
      default: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' },
   };

   //Parcels.
   if (mapTipSetting.layerName === "Z_Parcels") {
      jsx.push(<div key={Util.uid()} style={styles.parcels} title={mapTipSetting.layerName}>
         {getParcels(fields)}
      </div>);

   } else { //Default map tip.
      jsx.push(<div key={Util.uid()} style={styles.default} title={mapTipSetting.layerName}>
         {getDefault(mapTipSetting, fields)}
      </div>);
   }
   return jsx;
}

//Default map tip.
export function getDefault(mapTipSetting: Settings.iMapTip, fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   const styles: Default.iStyles = {
      black: { color: 'darkslategray', fontWeight: 500 },
      green: { color: 'darkgreen', fontWeight: 500 },
      red: { color: 'maroon', fontWeight: 500 },
   };

   for (const field of fields) {
      if (Settings.security.accessLevel >= field.accessLevel) {
         if (field.value !== "") {
            jsx.push(<div key={Util.uid()}>
               <Typography component="span" style={styles.red} variant="body2">{field.alias}:&nbsp;</Typography>
               <Typography component="span" style={styles.black} variant="body2">{field.value}</Typography>
            </div>);
         }
      }
   }
   //for (const field of fields) {
   //   if (Settings.security.accessLevel >= field.accessLevel) {
   //      if (field.value !== "") {
   //         if (i > 0) {
   //            jsx.push(<span key={Util.uid()}>&nbsp;&nbsp;&nbsp;</span>);
   //         }
   //         jsx.push(<Typography key={Util.uid()} style={styles.default} variant="body2">{field.value}</Typography>);
   //         i++;
   //      }
   //   }
   //}
   return jsx;
}

//Parcels.
function getParcels(fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   const styles: any = {
      black: { color: 'black', fontWeight: 500 },
      red: { color: 'darkred', fontWeight: 500 },
      green: { color: 'green', fontWeight: 500 },
   };

   let pin: string;
   let siteAddress: string;
   let beds: number;
   let baths: number;
   let sqFt: any;
   let mrkLand: any;
   let mrkImp: any;
   let mrkTotal: any;
   let pictureLinks: string;
   let sketchLinks: string;

   for (const field of fields) {
      if (field.name.Equal("pin")) {
         pin = field.value;

      } else if (field.name.Equal("siteAddress")) {
         siteAddress = field.value;

      } else if (field.name.Equal("Bedrooms")) {
         beds = field.value;

      } else if (field.name.Equal("PictureLinks")) {
         pictureLinks = field.value;
      }
   }

   jsx.push(<div key={Util.uid()}>
      <span style={styles.red}>PIN:&nbsp;</span><span style={styles.black}>{pin}</span>
   </div>);

   //let fsLinks: string[];
   //fsLinks = Custom.addToLinks(pictureLinks, fsLinks);

   //for (const url of fsLinks) {
   //   jsx.push(<img key={Util.uid()} width={330} style={{ cursor: "pointer" }} alt="Picture" src={url} onClick={openImgInNewWindow.bind(null, url)} />);
   //}
   return jsx;
}

//Show photo in new browser window.
function openImgInNewWindow(url: string) {
   window.open(url, "Picture");
}
